import { memo } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

import { do_speed_frequency_chart_options } from '../assets/assets_functions'

import { langSpeedFrequencyChart } from '../assets/langSpeedFrequencyChart'
import { useLang } from '../utils/hooks'

const SpeedFrequencyChart = ({ data }) => {
  const { lang } = useLang()
  const choosenLang =
    lang === 'fr' ? langSpeedFrequencyChart.fr : langSpeedFrequencyChart.eng
  const speedFrequencyChartOptions = do_speed_frequency_chart_options(
    data,
    choosenLang.speedFreqChartTitle,
    choosenLang.speedFreqChartY
  )
  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={speedFrequencyChartOptions}
    />
  )
}

export default memo(SpeedFrequencyChart)
